<section class="app-pro-exp-exp" [appAnimate]="'landing'" [speed]="'faster'" [aos]="0.2">
  <h2 class="app-pro-exp-exp__tit">EKSPERCI</h2>
  <div class="app-pro-exp-exp__cont">
    <swiper-container [config]="swiperConfig" class="app-pro-exp-exp__cont__swi" wwwSwiper init="false">
      <swiper-slide [ngClass]="{ 'app-pro-exp-exp__cont__swi__sl': true }" swiperSlide role="button">
        <div class="app-pro-exp-exp__cont__swi__sl__box">
          <img
            class="app-pro-exp-exp__cont__swi__sl__box__img d-block"
            [src]="'assets/images/pages/account/pro-experience/networking/iza-pawinska.webp'"
            [alt]="'Iza Pawińska'"
          />

          <div class="app-pro-exp-exp__cont__swi__sl__box__txt">
            <h2 class="app-pro-exp-exp__cont__swi__sl__box__txt__tit">IZA PAWIŃSKA W JEDNYM ZDANIU:</h2>
            <p class="app-pro-exp-exp__cont__swi__sl__box__txt__des">
              <b
                >Piorun kulisty pozytywnej energii otwarty na wyzwania, kreatywny do bólu, szukający rozwiązań i
                pomagający z pasją i entuzjazmem.</b
              >
              <br /><br />
              Od ponad 25 lat jest trenerem w branży Beauty Pracuje dla marek luksusowych Jej naturalną przestrzenią
              jest świat zapachów, pielęgnacji i makijażu Podczas prezentacji, szkoleń, warsztatów, webinarów, liveów i
              formatów YT przekazuje sw oim odbiorcom wiedzę jak stworzyć, wydobyć i podkreślić piękno zewnętrzne Jak
              zatrzymać, lub odwrócić czas? Jak za pomocą odpowiednio dobranego zapachu poczuć się wspaniale i zrobić
              wrażenie na innych
            </p>
          </div>
        </div>
      </swiper-slide>

      <swiper-slide [ngClass]="{ 'app-pro-exp-exp__cont__swi__sl': true }" swiperSlide role="button">
        <div class="app-pro-exp-exp__cont__swi__sl__box">
          <img
            class="app-pro-exp-exp__cont__swi__sl__box__img d-block"
            [src]="'assets/images/pages/account/pro-experience/networking/aleksandra-dworska.webp'"
            [alt]="'Aleksandra Dworska'"
          />
          <div class="app-pro-exp-exp__cont__swi__sl__box__txt">
            <h2 class="app-pro-exp-exp__cont__swi__sl__box__txt__tit">ALEKSANDRA DWORSKA W JEDNYM ZDANIU:</h2>
            <p class="app-pro-exp-exp__cont__swi__sl__box__txt__des">
              <b>Pasjonatka branży beauty oraz budowania silnych marek w branży beauty z naciskiem na LUKSUS.</b>
              <br /><br />
              Wspiera, edukuje i inspiruje właścicielki i menedżerki miejsc beauty, prowadząc konsultacje, salonowe
              rewolucje i kluczowy projekt online LUKSUS W BEAUTY – mówiąc o strategiach największych marek luksusowych
              i jak ich strategię przenieść do branży beauty. Jej misją jest pomaganie w rozwoju, wprowadzaniu
              innowacyjnych rozwiązań i budowaniu silnych, rozpoznawalnych marek. Jest autorką licznych webinariów,
              dokumentów dla salonów i ebooków, oferując praktyczne porady i strategie, które ułatwiają codzienne
              zarządzanie i planowanie rozwoju biznesu w branży beauty. Współwłaścicielka pierwszego w Polsce systemu do
              pełnej dokumentacji salonów online www.beautycheck.pl.
            </p>
          </div>
        </div>
      </swiper-slide>
    </swiper-container>

    <div class="app-pro-exp-exp__cont__swi__nav">
      <div class="app-pro-exp-exp__cont__swi__nav--prev"></div>
      <div class="app-pro-exp-exp__cont__swi__nav--pag"></div>
      <div class="app-pro-exp-exp__cont__swi__nav--next"></div>
    </div>
  </div>
</section>
